export const CONNECTION_EDIT_TITLE_TEXT = {
    id: 'oe.blueprints.connection.edit.title',
    defaultMessage: 'Edit Connection Template',
    description: 'Popover header text'
};

export const CONNECTION_CREATE_TITLE_TEXT = {
    id: 'oe.blueprints.connection.create.title',
    defaultMessage: 'New Connection Template',
    description: 'Popover header text'
};

export const NEW_CONNECTION_TEMPLATE_TEXT = {
    id: 'oe.blueprints.newConnectionTemplate',
    defaultMessage: '+ New Connection Template',
    description: 'Button label',
};

export const NO_CONNECTION_TEMPLATES_TEXT = {
    defaultMessage: 'No Connection Templates have been created in this account.',
    id: 'oe.blueprints.noConnectionTemplates',
    description: 'Placeholder text',
};

export const VIEW_CONNECTION_TEMPLATE_DETAILS_TEXT = {
    id: 'oe.blueprint.details.viewConnectionTemplateDetails',
    defaultMessage: 'View Connection Template Details',
    description: 'Popover title'
};


export const BLUEPRINT_CONNECTION_TABLE_NAME_TEXT = {
    id: 'oe.blueprints.name',
    defaultMessage: 'Name',
    description: 'Label text'
};

export const BLUEPRINT_CONNECTION_TABLE_DATE_CREATED_TEXT = {
    id: 'oe.blueprints.dateCreated',
    defaultMessage: 'Date Created',
    description: 'Label text'
};

export const BLUEPRINT_CONNECTION_TABLE_DATE_MODIFIED_TEXT = {
    id: 'oe.blueprints.dateModified',
    defaultMessage: 'Date Modified',
    description: 'Label text'
};

export const BLUEPRINT_CONNECTION_TABLE_DATE_DESCRIPTION_TEXT = {
    id: 'oe.blueprints.description',
    defaultMessage: 'Description',
    description: 'Label text'
};